





























































import Vue, { PropType } from 'vue';
import { Doc } from '@/modules/doc';
// import { formatHourMinute } from '@/modules/calender';
import { calender } from 'mostra';
import { FirestoreDate } from '@/modules/firestore';

export default Vue.extend({
  name: 'GChatMessage',
  props: {
    senderCID: {
      type: String as PropType<string>,
      default: '',
    },
    avatar: {
      type: String as PropType<string>,
      default: '',
    },
    name: {
      type: String as PropType<string>,
      default: '',
    },
    company: {
      type: String as PropType<string>,
      default: '',
    },
    date: {
      type: [Date, Object] as PropType<FirestoreDate | Date>,
    },
    text: {
      type: String as PropType<string>,
      default: '',
    },
    docs: {
      type: Array as PropType<Doc[]>,
      default: () => [],
    },
    isActivate: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    isInappropriate: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    withVideoUrl: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    videoUrl: {
      type: String as PropType<string>,
      default: '',
    },
    isOwner: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    isSeen: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      displayDate: calender.formatHourMinute(this.date),
    };
  },
  methods: {
    onClickDelete() {
      this.$emit('delete');
    },
    onClickVideo(val: string) {
      const regex = RegExp(/http:\/\/|https:\/\//);
      const isValidUrl = regex.test(val);
      if (!isValidUrl) {
        window.open(`http://${val}`, '_blank');
        return;
      }
      window.open(val, '_blank');
    },
    async onClickDownloadFile(val: string) {
      console.log('download', val);
    },
  },
});
